export default {
  methods: {
    openUrlInNewTab(url) {
      const urlAlreadyHasQueryParams = url.indexOf('?') !== -1;
      window.open(`${url}${urlAlreadyHasQueryParams ? '&' : '?'}tokenId=${this.$token.get()}`, '_blank');
    }
  }
};
